export const environment = {
    production: false,
    azureAppURL: 'https://repextest.azurewebsites.net',
    name: 'test'
  };
